module.exports = __webpack_public_path__ + "notificationAsset.40c636d.jpeg";